import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const CGU = () => (
    <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        Conditions Générales d’Utilisation (CGU)
      </Typography>

      <Typography
        variant="subtitle2"
        align="center"
        className="cgu-date"
        gutterBottom
      >
        Dernière mise à jour : [18/09/2025]
      </Typography>

      <Divider className="cgu-divider" />

      <Typography variant="h6" gutterBottom>1. Objet</Typography>
      <Typography paragraph>
        Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de définir les modalités d’accès et d’utilisation du site {" "}  
        {""} <a
            href="https://cooptaleo.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
           cooptaleo.com
        </a> {""} (ci-après « la Plateforme »), solution de mise en relation entre entreprises, recruteurs indépendants et talents IT, éditée par CIT MENA INFORMATION TECHNOLOGY CONSULTANCY (ci-après « l’Éditeur »). En utilisant la Plateforme, l’utilisateur accepte pleinement et sans réserve les présentes CGU.
      </Typography>

      <Typography variant="h6" gutterBottom>2. Accès au site et conditions d’inscription</Typography>
      <Typography paragraph>
        L’accès à la Plateforme est gratuit pour toute personne disposant d’une connexion Internet. Certaines fonctionnalités nécessitent la création d’un compte utilisateur (Entreprise, Recruteur ou Candidat). L’utilisateur doit être âgé d’au moins 18 ans pour s’inscrire sur la Plateforme, celle-ci étant exclusivement destinée à un public majeur en âge d’exercer une activité professionnelle. Lors de son inscription, l’utilisateur s’engage à fournir des informations exactes, complètes et à jour. L’utilisateur est responsable de la confidentialité de ses identifiants et mot de passe. Toute utilisation frauduleuse de son compte engage sa responsabilité. L’Éditeur ne peut être tenu responsable des défaillances techniques liées au matériel ou à la connexion Internet de l’utilisateur. La création d’un compte vaut acceptation pleine et entière des présentes CGU.
      </Typography>

      <Typography variant="h6" gutterBottom>3. Description des services</Typography>
      <Typography paragraph>
         La Plateforme propose notamment :
      </Typography>
      <ul className="cgu-list">
        <li>Entreprises : publication de besoins, consultation de profils, gestion de candidatures, suivi des recrutements.</li>
        <li>Recruteurs indépendants : accès à des missions IT qualifiées, proposition de profils, suivi des candidatures et des primes de succès.</li>
        <li>Candidats : dépôt de CV, gestion de profil, mise en relation avec recruteurs et entreprises.</li>
      </ul>
      <Typography paragraph>
        Certaines fonctionnalités peuvent être restreintes selon le type de compte et/ou soumises à conditions financières définies dans les Conditions Générales de Vente (CGV). L’Éditeur se réserve le droit de modifier ou de supprimer des services ou fonctionnalités à tout moment.
      </Typography>

      <Typography variant="h6" gutterBottom>4. Utilisation du site : engagements et interdictions</Typography>
      <Typography paragraph>
         L’utilisateur s’engage à :
      </Typography>
      <ul className="cgu-list">
        <li>respecter les lois et règlements en vigueur,</li>
        <li>ne pas usurper l’identité d’un tiers,</li>
        <li>ne pas diffuser de contenus illicites, diffamatoires, offensants ou discriminatoires,</li>
        <li>ne pas utiliser la Plateforme à des fins commerciales non autorisées,</li>
        <li>ne pas procéder à l’extraction automatisée de données (scraping, API non autorisée…)</li>
        <li>ne pas créer ou publier de profils fictifs ou trompeurs.</li>
      </ul>
      <Typography paragraph>
        L’utilisateur est seul responsable des informations transmises et des conséquences liées à leur diffusion.
      </Typography>

      <Typography variant="h6" gutterBottom>5. Responsabilité de l’Éditeur</Typography>
      <Typography paragraph>
        L’Éditeur met tout en œuvre pour assurer le bon fonctionnement de la Plateforme, mais ne saurait être tenu responsable :
      </Typography>
      <ul className="cgu-list">
        <li>en cas d’indisponibilité temporaire ou d’interruption pour maintenance, mise à jour ou raisons de sécurité,</li>
        <li>en cas d’anomalies techniques indépendantes de sa volonté,</li>
        <li>en cas d’utilisation abusive ou frauduleuse de la Plateforme par un utilisateur.</li>
      </ul>
      <Typography paragraph>
       L’Éditeur n’intervient pas dans la relation contractuelle finale entre entreprises, recruteurs et candidats, et ne garantit ni l’issue d’un recrutement, ni la qualité des profils, ni l’engagement des parties. La responsabilité de l’Éditeur est limitée aux seuls dommages directs, dans la limite du montant payé par l’utilisateur pour l’accès au service concerné.
      </Typography>

      <Typography variant="h6" gutterBottom>6. Données personnelles</Typography>
      <Typography paragraph>
      Le traitement des données personnelles est régi par la Politique de confidentialité (RGPD), disponible à l’adresse suivante :          <a
            href="https://cooptaleo.com/confidentiality"
            style={{ textDecoration: "underline", color: "blue" }}
          >
          https://cooptaleo.com/confidentiality
        </a>. L’utilisateur dispose des droits d’accès, de rectification, de suppression et de portabilité de ses données, conformément à la réglementation applicable.
      </Typography>

      <Typography variant="h6" gutterBottom>7. Propriété intellectuelle</Typography>
      <Typography paragraph>
       Tous les contenus présents sur la Plateforme (logos, textes, images, éléments graphiques et techniques, architecture logicielle, bases de données) sont protégés par les lois en vigueur sur la propriété intellectuelle. Toute reproduction, diffusion ou exploitation, totale ou partielle, sans autorisation écrite préalable de l’Éditeur, est strictement interdite.
      </Typography>

      <Typography variant="h6" gutterBottom>8. Liens externes</Typography>
      <Typography paragraph>
       La Plateforme peut contenir des liens hypertextes vers d’autres sites internet. L’Éditeur n’exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
      </Typography>

      <Typography variant="h6" gutterBottom>9. Durée et résiliation</Typography>
      <Typography paragraph>
       L’utilisateur peut supprimer son compte à tout moment depuis son espace personnel ou en contactant l’Éditeur. L’Éditeur se réserve le droit de suspendre ou de résilier un compte utilisateur en cas de non-respect des présentes CGU, de fraude ou d’utilisation abusive.
      </Typography>

      <Typography variant="h6" gutterBottom>10. Modification des CGU</Typography>
      <Typography paragraph>
      L’Éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification lors de leur prochaine connexion, et devront accepter la nouvelle version pour continuer à utiliser la Plateforme.
      </Typography>

      <Typography variant="h6" gutterBottom>11. Notifications et communications</Typography>
      <Typography paragraph>
      Toute communication officielle entre l’Éditeur et l’utilisateur sera réputée valable si elle est effectuée par e-mail à l’adresse renseignée lors de l’inscription.
      </Typography>

      <Typography variant="h6" gutterBottom>12. Langue de référence</Typography>
      <Typography paragraph>
      En cas de divergence d’interprétation entre plusieurs versions linguistiques des CGU, seule la version en langue française fait foi.
      </Typography>

      <Typography variant="h6" gutterBottom>13. Juridiction compétente</Typography>
      <Typography paragraph>
      En cas de litige, les tribunaux compétents seront ceux du ressort du siège social de l’Éditeur, sauf dispositions légales impératives contraires.
      </Typography>
    </Box>
  </Container>
<Footer />

  </>
);

export default CGU;
